import type { PriceWithInterval } from '~/util/getPriceWithInterval';

const getAppPriceRaw = (
  appPrice: PriceWithInterval | Array<PriceWithInterval> | null | undefined,
): number | null =>
  Array.isArray(appPrice)
    ? appPrice[0]?.amount
      ? appPrice[0].amount / 100
      : null
    : appPrice?.amount
      ? appPrice.amount / 100
      : null;

export default getAppPriceRaw;
